import axios from 'axios';
import { AxiosError } from 'axios';
import { readToken, deleteToken } from '@app/services/localStorage.service';

/** Lý do bị đăng xuất, hiển thị một lần ở trang đăng nhập. */
export const SIGN_OUT_NOTICE_KEY = 'signOutNotice';

export const takeSignOutNotice = (): string | null => {
  const notice = sessionStorage.getItem(SIGN_OUT_NOTICE_KEY);
  if (notice) sessionStorage.removeItem(SIGN_OUT_NOTICE_KEY);
  return notice;
};

export const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosApi.interceptors.request.use(
  function (request) {
    const tokenData = readToken();

    if (tokenData) {
      const newHeaders = {
        ...request.headers,
        'access-token': tokenData['accessToken'],
        uid: tokenData['uid'],
        client: tokenData['client'],
      };

      request = {
        ...request,
        headers: newHeaders,
      };
    }
    return request;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;

    if (status === 401) {
      // Phiên bị admin thu hồi / hết hạn do không hoạt động: giữ lý do để trang đăng nhập nói rõ,
      // thay vì người dùng thấy mình "tự nhiên" bị đá ra.
      const data = error.response?.data as { code?: string; error?: string } | undefined;
      if (data?.code?.startsWith('session_') && data.error) {
        sessionStorage.setItem(SIGN_OUT_NOTICE_KEY, data.error);
      }
      deleteToken();
      window.location.href = '/auth/login';
    } else if (status === 403) {
      // Chỉ redirect khi CHƯA ở trang 403 — trang /403 vẫn chạy các call nền
      // (me/notifications/app_settings...), nếu một call nền dính 403 mà redirect
      // tiếp sẽ reload trang vô hạn (từng xảy ra với user sales).
      if (window.location.pathname !== '/403') {
        window.location.href = '/403';
      }
    } else if (status !== undefined && status >= 500) {
      const errorContext = {
        url:     error.config?.url ?? '(unknown)',
        method:  (error.config?.method ?? 'GET').toUpperCase(),
        status,
        message: (error.response?.data as any)?.error ?? error.message ?? 'Internal server error',
        time:    new Date().toISOString(),
      };
      localStorage.setItem('lastServerError', JSON.stringify(errorContext));
      window.location.href = '/server-error';
    }

    return Promise.reject(error);
  }
);